import { PlantFormTabs } from "./PlantFormTabs";
import { plantDefaultValues } from "./PlantDefaultValues";
import Plant from "../Plant";
import { useAddPlant } from "../Hooks/useAddPlant";
import { nameOf } from "../../Utils/nameOf";

export const AddPlant = () => {
  const { mutate: addPlant } = useAddPlant();

  const disabledFields: Array<string> = [
    nameOf<Plant>("CountryIsoCode"),
    nameOf<Plant>("MapAndGuideLatitude"),
    nameOf<Plant>("MapAndGuideLongitude"),
  ];

  return (
    <PlantFormTabs
      title="Add Plant"
      plant={plantDefaultValues}
      onSave={(plant: Plant) => addPlant(plant)}
      disabledFields={disabledFields}
    />
  );
};
